"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _typeof2 = _interopRequireDefault(require("@babel/runtime/helpers/typeof"));

var _immutable = require("immutable");

var PropertyValueRecord = (0, _immutable.Record)({
  name: undefined,
  source: null,
  sourceId: null,
  timestamp: null,
  value: undefined,
  versions: (0, _immutable.List)()
}, 'PropertyValueRecord');

PropertyValueRecord.fromJS = function (json) {
  if (!json || (0, _typeof2.default)(json) !== 'object') {
    return json;
  }

  return PropertyValueRecord((0, _immutable.fromJS)(json) // TODO colby: disabling this for now until we can figure out how to handle
  // the different formats
  // .update(
  //   'versions',
  //   (versions) -> versions?.map(PropertyValueVersionRecord.fromJS) ? List()
  // )
  );
};

var _default = PropertyValueRecord;
exports.default = _default;
module.exports = exports.default;